import ModusServiceCollection from "../ModusServiceCollection";
import LaboratoryContactModel from "../../models/modus/LaboratoryContactModel";

/**
 * LaboratoryContact collection
 */
export default class LaboratoryContactCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return LaboratoryContactModel;
  }

}
